import React from "react";
import LoginContent from "../../components/UserAccess/Login/LoginContent";

const LoginPage = () => {
  return (
    <>
      <LoginContent />
    </>
  );
};

export default LoginPage;
